export class ForecastTemplateConstants {
}
ForecastTemplateConstants.StockLevelsOutput = 'Stock Levels';
ForecastTemplateConstants.HistoricalAndForecastOutput = 'Historical & Forecast';
ForecastTemplateConstants.UnderstockLossesOutput = 'Understock Losses';
ForecastTemplateConstants.UnderstockLocationLossesOutput = 'Losses by Location';
ForecastTemplateConstants.ForecastDetailOutput = 'Forecast Detail';
ForecastTemplateConstants.StockLevelsDetailOutput = 'Stock Levels Detail';
// todo: these constants were added by Jon, would be nice if the backend actually used them
ForecastTemplateConstants.HistoricalAndForecastDateColumn = 'Date';
ForecastTemplateConstants.HistoricalAndForecastForecastColumn = 'Forecast';
ForecastTemplateConstants.HistoricalAndForecastUnitsColumn = 'Units Sold';
ForecastTemplateConstants.HistoricalAndForecastRevenueColumn = 'Revenue';
ForecastTemplateConstants.HistoricalAndForecastCostColumn = 'Cost';
ForecastTemplateConstants.StockLevelsStockLevelColumn = 'Stock Level';
ForecastTemplateConstants.StockLevelsStockCountColumn = 'Count';
ForecastTemplateConstants.StockLevelsVeryLow = 'Very Low';
ForecastTemplateConstants.StockLevelsLow = 'Low';
ForecastTemplateConstants.StockLevelsOptimal = 'Optimal';
ForecastTemplateConstants.StockLevelsHigh = 'High';
ForecastTemplateConstants.StockLevelsVeryHigh = 'Very High';
ForecastTemplateConstants.UnderstockLocationLossesLocationColumn = 'Location ID';
ForecastTemplateConstants.UnderstockLocationLossesRevenueColumn = 'Revenue';
ForecastTemplateConstants.UnderstockLossesSKUColumn = 'SKU';
ForecastTemplateConstants.UnderstockLossesLostRevenueColumn = 'Lost Revenue';
//# sourceMappingURL=forecastTemplateConstants.js.map